import {
  COOKIESPOLICY_CMS_DATA,
  COOKIESPOLICY_TABLE_CMS_DATA,
  SHOW_LOADER,
} from './CookiesPolicyActionTypes';

const initialState = {
  cookiesPolicyCMSData: [],
  cookiesPolicyTableCMSData: [],
};

export const cookiesPolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case COOKIESPOLICY_CMS_DATA:
      return {
        ...state,
        cookiesPolicyCMSData: action.payload,
      };
    case COOKIESPOLICY_TABLE_CMS_DATA:
      return {
        ...state,
        cookiesPolicyTableCMSData: action.payload,
      };
    case SHOW_LOADER:
      return {
        ...state,
        isLoader: action.isLoader,
      };
    default:
      return state;
  }
};
